<div class="card">
    <div class="card-header">
        <h4>General</h4>
        <form class="form-inline" [formGroup]="contactGeneralInfo">
            <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" id="individual-switch" formControlName="isIndividual" />
                <label class="custom-control-label" for="individual-switch">Individual</label>
            </div>            
            <button type="submit" class="btn btn-primary btn-sm" (click)="save($event)">Save</button>
        </form>
    </div>
    <div>
        <div class="card-body">
            <form [formGroup]="contactGeneralInfo">
                <div class="form-row">
                    @if (!isIndividual) {
                    <div class="form-group col-sm-12 col-lg">
                        <label>Company Name</label>
                        <input class="form-control form-control-sm" type="text" formControlName="companyName">
                    </div>
                    }
                    @if (isIndividual) {
                    <div class="form-group col-md-2 col-xl-1 col-sm-12">
                        <label>Title</label>
                        <input class="form-control form-control-sm" type="text" formControlName="title">
                    </div>
                    }
                    <div class="form-group col-sm-12 col-lg">
                        <label>First Name</label>
                        <input class="form-control form-control-sm" type="text" formControlName="firstName">
                    </div>
                    @if (isIndividual) {
                    <div class="form-group col-sm-12 col-lg">
                        <label>Middle Name</label>
                        <input class="form-control form-control-sm" type="text" formControlName="middleName">
                    </div>
                    }
                    <div class="form-group col-sm-12 col-lg">
                        <label>Last Name</label>
                        <input class="form-control form-control-sm" type="text" formControlName="lastName">
                    </div>
                    @if (isIndividual) {
                    <div class="form-group col-md-2 col-xl-1 col-sm-12">
                        <label>Suffix</label>
                        <input class="form-control form-control-sm" type="text" formControlName="suffix">
                    </div>
                    }
                </div>
                <div class="form-row">
                    <div class="form-group col-lg-4 col-md-6 col-sm-12">
                        @if (!isIndividual) {
                            <label>EIN</label>
                        }
                        @if (isIndividual) {
                            <label>Social Security Number</label>
                        }
                        <input class="form-control form-control-sm" type="text" formControlName="taxPayerNumber">
                    </div>
                    @if (isIndividual) {
                    <div class="form-group col-lg-4 col-md-6 col-sm-12">
                        <label>Date of Birth</label>
                        <input class="form-control form-control-sm" type="date" formControlName="birthdate">
                    </div>
                    }
                </div>
            </form>
        </div>
    </div>
</div>
